import axios from "axios";
import { authHeader } from "../helpers/authHeader";

const baseUrl = process.env.REACT_APP_SERVER_URL;
// const configUrl = "https://wildxr-api-qa.azurewebsites.net"

const axiosInstance = axios.create({
  baseURL: baseUrl,
});

axiosInstance.defaults.headers.common["Authorization"] = authHeader();
axiosInstance.defaults.headers.common["Content-Type"] =
  "application/json;charset=UTF-8";
axiosInstance.defaults.headers.common["accept"] =
  "application/json, text/plain, */*";

// Add a response interceptor
axiosInstance.interceptors.response.use(
  function (response) {
    if (response.status === 200) localStorage.setItem("userAuthorized", "true");
    return response;
  },
  function (error) {
    if (
      error.response &&
      (401 === error.response.status || 403 === error.response.status)
    ) {
      localStorage.setItem("userAuthorized", "false");
      window.location.href = "/unauthorized";
    } else {
      return Promise.reject(error);
    }
  }
);

export default axiosInstance;
